export const productTypeLabelMap: { [key: string]: string } = {
  HO3: "Homeowners policy",
  HO4: "Renters policy",
  HO6: "Condo policy",
  HWO: "Wind only policy",
  MHO: "Manufactured home policy",
  DP3: "Dwelling property policy",
  BOP: "Business Owner policy",
};
